import { useEffect, useRef } from 'react';
import { useReportStore, restoreReportSnapshot, type ReportState } from '@/entities/report';

type TabRef = { current?: { resetData?: () => void } | null };

export type DebugObserverProps = {
  beatsRef: TabRef;
  ecgEventsRef: TabRef;
  stripsRef: TabRef;
  pdfReportRef: TabRef;
  hrSummaryRef: TabRef;
};

const DebugObserver = ({
  beatsRef,
  ecgEventsRef,
  stripsRef,
  pdfReportRef,
  hrSummaryRef,
}: DebugObserverProps): null => {
  const actionSnapshot = useReportStore((s) => s.actionSnapshot);
  const setActionSnapshot = useReportStore((s) => s.actions.setActionSnapshot);
  const savedSnapshot = useRef<ReportState>();
  useEffect(() => {
    if (actionSnapshot === 1) {
      savedSnapshot.current = useReportStore.getState();
      setActionSnapshot(0);
    }
    if (actionSnapshot === 2 && savedSnapshot.current) {
      restoreReportSnapshot(savedSnapshot.current);
      beatsRef.current?.resetData();
      ecgEventsRef.current?.resetData();
      stripsRef.current?.resetData();
      pdfReportRef.current?.resetData();
      hrSummaryRef.current?.resetData();
      setActionSnapshot(0);
    }
  }, [actionSnapshot]);
  return null;
};
export default DebugObserver;
